import React, { memo } from 'react';

const Background = memo(() => (
    <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-0 left-0 w-full h-full bg-slate-900 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-indigo-900 via-slate-900 to-black"></div>
        <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-purple-500/30 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-float-delayed"></div>
        <div className="absolute top-[20%] right-[20%] w-72 h-72 bg-pink-500/20 rounded-full blur-3xl animate-pulse-slow"></div>
    </div>
));

Background.displayName = 'Background';

export default Background;
